import React from 'react';
import cn from 'classnames';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import UserCoreBadge from '../_partials/UserCoreBadge';
import UserSymbol from '../_partials/UserSymbol';
import { getUserType, getUserTypeId } from '../helpers';
import s from './BasicUserName.scss';
export const BasicUserName = /*#__PURE__*/ React.memo(({ user , showSymbol =true , symbolOpensPopup , symbolClassName , useCoreRibbon , usernameClassName , coreRibbonClassname , 'data-hook': dataHook  })=>{
    const userType = getUserType(user);
    const isCoreUser = userType.includes('core');
    const showCoreBadge = isCoreUser && showSymbol && useCoreRibbon;
    return /*#__PURE__*/ React.createElement(BiLoggerContextProvider, {
        value: {
            typeid: getUserTypeId(user),
            itemid: user.userId
        }
    }, /*#__PURE__*/ React.createElement("span", {
        className: usernameClassName !== null && usernameClassName !== void 0 ? usernameClassName : s['data-hook-wrapper'],
        "data-hook": dataHook
    }, user.username), showCoreBadge && /*#__PURE__*/ React.createElement(UserCoreBadge, {
        corePackage: userType,
        size: "large",
        className: cn(s['core-badge'], symbolClassName, coreRibbonClassname),
        openUserSymbolPopup: symbolOpensPopup
    }), showSymbol && !showCoreBadge && /*#__PURE__*/ React.createElement(UserSymbol, {
        userType: getUserType(user),
        className: symbolClassName,
        openUserSymbolPopup: symbolOpensPopup
    }));
});
BasicUserName.displayName = 'BasicUserName';
export default BasicUserName;
